import { format, parseISO } from 'date-fns';

interface DateDisplayOptions {
  showYear?: boolean;
  showMonth?: boolean;
  showDay?: boolean;
  showHour?: boolean;
  showMinute?: boolean;
  showSecond?: boolean;
}

export const isoDateToDisplayString = (
  isoDate: string,
  {
    showYear = true,
    showMonth = true,
    showDay = true,
    showHour = true,
    showMinute = true,
    showSecond = true,
  }: DateDisplayOptions = {},
) => {
  const dateTokens: string[] = [];
  if (showYear) dateTokens.push('yyyy');
  if (showMonth) dateTokens.push('MM');
  if (showDay) dateTokens.push('dd');

  const timeTokens: string[] = [];
  if (showHour) timeTokens.push('HH');
  if (showMinute) timeTokens.push('mm');
  if (showSecond) timeTokens.push('ss');

  let pattern = '';
  if (dateTokens.length) pattern += dateTokens.join('/');
  if (timeTokens.length) {
    if (pattern) pattern += ' ';
    pattern += timeTokens.join(':');
  }

  return format(parseISO(isoDate), pattern);
};
